<template>
  <div>
    <div class="row">
      <div class="col">
        <span class="search-header">{{ $t("pages.payroll.searching_header") }}</span>
        <img src="@/assets/IC_Minimise.png" alt="min" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <form>
          <div class="form-row">
            <div class="col-md-6">
              <department-list-field id="department" name="department" :form="form" />
            </div>
            <div class="col-md-6">
              <establishment-list-field id="establishment" name="establishment" :form="form" />
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <employee-list-field
                id="employee"
                name="employee"
                :form="form"
                :department-code="selectedDepartmentCode"
                :establishment-code="selectedEstablishmentCode"
              />
            </div>
            <div class="col-md-3" v-if="!isDay">
              <month-field :form="form" name="month" />
            </div>
            <div class="col-md-3" v-if="!isDay">
              <year-field :form="form" name="year" />
            </div>
            <div class="offset-md-1 col-md-2" v-if="isDay">
              <day-field id="date" :form="form" name="day" />
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col text-right">
        <a href="#" class="mx-4 search-clean" @click.prevent="clear">{{
          $t("components.actions.clear")
        }}</a>
        <vue-button
          :title="$t('components.actions.search')"
          class="btn-primary search-button"
          @click="seachClicked"
        ></vue-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  EmployeeListField,
  YearField,
  MonthField,
  DayField,
  DepartmentListField,
  EstablishmentListField,
} from "@/pages/components/fields";
import { VueButton, Form, Options } from "@/components/form";

import {
  SUC_SELECT_CHANGED_EVENT,
  SUC_PERIOD_CHANGED_EVENT,
  DATE_PERIOD_DAY,
} from "@/components/form";
import { PLANNING_SEARCH_CHANGED_EVENT } from "./index";

export default {
  components: {
    EmployeeListField,
    YearField,
    MonthField,
    VueButton,
    DayField,
    DepartmentListField,
    EstablishmentListField,
  },
  data() {
    return {
      date: new Date(),
      type: null,
      form: new Form({
        data: {
          day: null,
          month: null,
          year: null,
          employee: null,
          department: null,
          establishment: null,
        },
        options: {
          ...new Options().add("employee", "employeeCode"),
          ...new Options().add("department", "departmentCode"),
          ...new Options().add("establishment", "establishmentCode"),
          ...new Options().add("month", "id"),
        },
      }),
    };
  },
  computed: {
    selectChangeEvent() {
      return SUC_SELECT_CHANGED_EVENT;
    },
    isDay() {
      return this.type == DATE_PERIOD_DAY;
    },
    selectedDepartmentCode() {
      const dept = this.form.data().department;
      console.log("department data:", dept);
      // Since Options is configured to save the departmentCode directly, dept is already the code
      const result = dept || null;
      console.log("selectedDepartmentCode computed:", result);
      return result;
    },
    selectedEstablishmentCode() {
      const est = this.form.data().establishment;
      console.log("establishment data:", est);
      // Since Options is configured to save the establishmentCode directly, est is already the code
      const result = est || null;
      console.log("selectedEstablishmentCode computed:", result);
      return result;
    },
  },
  created() {
    EventBus.listen(SUC_PERIOD_CHANGED_EVENT, (args) => {
      this.type = args.type;
    });
  },
  beforeDestroy() {
    EventBus.off(SUC_PERIOD_CHANGED_EVENT);
  },
  methods: {
    init() {},
    clear() {
      console.log("=== FORM CLEAR ===");
      this.form.reset();
      const clearPayload = { date: this.formDate({}), type: this.type };
      console.log("Clear payload sent:", clearPayload);
      EventBus.fire(PLANNING_SEARCH_CHANGED_EVENT, clearPayload);
    },
    seachClicked() {
      let data = this.form.data();
      console.log("=== FORM SUBMIT ===");
      console.log("Form data:", data);
      console.log("Selected employee:", data.employee);
      console.log("Selected department:", data.department);
      console.log("Selected establishment:", data.establishment);

      let payload = { date: this.formDate(data), type: this.type, ...data };
      console.log("Complete payload sent:", payload);

      EventBus.fire(PLANNING_SEARCH_CHANGED_EVENT, payload);
    },
    formDate(data) {
      let date = new Date();
      if (this.isDay && this.$isset(data.day)) {
        date = this.$parseDate(data.day);
      } else if (this.$isset(data.month) && this.$isset(data.year)) {
        date = new Date(data.year, data.month, 1);
      }
      return date;
    },
  },
};
</script>

<style lang="scss" scoped>
.payroll-action {
  padding-left: 5px;
  color: var(--portal-primary);

  & > img {
    margin-right: 5px;
  }
}

.search-header {
  color: var(--portal-secondary);
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22.4px;
  margin-right: 5px;
}

.search-button {
  border-radius: $border-radius;
  height: 50px;
  width: 125px;
}

.search-clean {
  color: var(--portal-text-muted) !important;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  text-decoration: none !important;

  &:hover {
    color: var(--portal-text) !important;
  }
}
</style>
